var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgQuestion(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12,22.5C6.21,22.5,1.5,17.79,1.5,12C1.5,6.21,6.21,1.5,12,1.5c5.79,0,10.5,4.71,10.5,10.5C22.5,17.79,17.79,22.5,12,22.5z  M12,3c-4.96,0-9,4.04-9,9c0,4.96,4.04,9,9,9c4.96,0,9-4.04,9-9C21,7.04,16.96,3,12,3z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12,16.5c-0.55,0-1,0.45-1,1s0.45,1,1,1s1-0.45,1-1S12.55,16.5,12,16.5"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12,15c-0.41,0-0.75-0.34-0.75-0.75v-1c0-1.22,0.87-1.9,1.63-2.49c0.85-0.66,1.37-1.11,1.37-2.01 c0-0.02-0.06-2.25-2.25-2.25c-2.11,0-2.47,2.11-2.51,2.35c-0.06,0.41-0.44,0.7-0.84,0.64c-0.41-0.06-0.7-0.43-0.64-0.84 C8.17,7.39,9.22,5,12,5c2.73,0,3.75,2.3,3.75,3.75c0,1.68-1.13,2.55-1.95,3.19c-0.67,0.52-1.05,0.84-1.05,1.31v1 C12.75,14.66,12.41,15,12,15z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestion);
export default __webpack_public_path__ + "static/media/question.5105f5e94923edcbc4299b711d1505df.svg";
export { ForwardRef as ReactComponent };